import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';

import { CreateUserScreen } from '@/modules/recognition/admin/presentation/screens/CreateUser';
import { Button } from '@/shared/presentation/components/ui/Button';
import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';

import { ApplicationViewModel } from './Application.vm';

const Users = observer(() => {
  const vm = useViewModel(ApplicationViewModel);

  const columns = useMemo(
    () => [
      {
        name: 'Email',
        selector: (row) => <Link to={`/admin/useaccountsrs/${row.guid}`}>{row.email}</Link>,
        sortable: true,
        filterable: true,
      },
      {
        name: 'Nome',
        selector: (row) => row.name,
        sortable: true,
        filterable: true,
      },
    ],
    [],
  );

  const actions = useMemo(() => [], []);

  const data = vm.users;

  return (
    <div>
      <DataTable
        columns={columns}
        data={data}
        actions={actions}
        headerActions={
          <Button
            icon="add"
            size="small"
            disabled={vm.isLoading}
            onClick={() => vm.openCreateModal()}
          >
            Adicionar conta
          </Button>
        }
      />
      <CreateUserScreen />
    </div>
  );
});

const ApplicationDetails = observer(() => {
  const vm = useViewModel(ApplicationViewModel);

  if (!vm.application) {
    return null;
  }

  return (
    <div>
      <p>GUID: {vm.application?.guid}</p>
      <p>Nome: {vm.application?.name}</p>
      <p>Descrição: {vm.application?.description}</p>
      <p>Organização: {vm.application?.organization.name}</p>
      <p>URL: {vm.application?.baseURL}</p>
      <p>Status: {vm.application?.status}</p>
    </div>
  );
});

const InfrastructureDetails = observer(() => {
  const vm = useViewModel(ApplicationViewModel);

  if (!vm.application) {
    return null;
  }

  return (
    <div>
      <p>Banco de dados: io-demo-db</p>
      <p>Tipo: Aurora Serverless</p>
      <p>Engine: Postgres 13.3</p>
      <p>Região: US-WEST-2</p>
      <p>URL: https://aws.amazon.com/us-west-2/io-demo-db</p>
    </div>
  );
});

export const ApplicationScreen = observer(() => {
  const params = useParams<{ guid: string }>();
  const vm = useViewModel(ApplicationViewModel, { guid: params.guid });

  return (
    <Page
      title={vm.application?.name}
      subtitle={vm.application?.description}
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar a aplicação."
      tabs={[
        {
          label: 'Detalhes',
          content: <ApplicationDetails />,
        },
        {
          label: 'Contas',
          content: <Users />,
        },
        {
          label: 'Convites',
          content: <div>Convites</div>,
        },
        {
          label: 'Infraestrutura',
          content: <InfrastructureDetails />,
        },
      ]}
    />
  );
});
